module.exports = __webpack_public_path__ + "img/fi-rr-billiard.d0b6589f.svg";